import { render, staticRenderFns } from "./CashWallet.vue?vue&type=template&id=85542e2a&scoped=true"
import script from "./CashWallet.vue?vue&type=script&lang=js"
export * from "./CashWallet.vue?vue&type=script&lang=js"
import style0 from "./CashWallet.vue?vue&type=style&index=0&id=85542e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85542e2a",
  null
  
)

export default component.exports